import { Suspense, useEffect } from 'react';

import { useBoundStore } from 'app/store';
import { FallbackWithLogo } from 'shared/ui';
import sendContentIcon from 'styles/images/send-consent-icon.svg';

import PdfForm from './PdfForm';

export const PdfFormPage = () => {
  const { ptNm } = useBoundStore((state) => state['hsptlzForm'].serviceParams);

  useEffect(() => {
    const handler = (e) => e.preventDefault();
    document.addEventListener('touchmove', handler, { passive: false });

    return () => {
      document.removeEventListener('touchmove', handler);
    };
  }, []);

  return (
    <PdfForm>
      <FallbackWithLogo
        title={
          <>
            {ptNm}님의 동의서를 <br />
            제출하고 있어요
          </>
        }
        subTitle={'잠시만 기다려 주세요.'}
        icon={sendContentIcon}
      />
      {/* pdf 저장 페이지 보이지 않도록 처리 */}
      <div name='gap' style={{ marginTop: '500px' }}></div>
      <Suspense>
        <PdfForm.TemplateContainer />
      </Suspense>
    </PdfForm>
  );
};
